var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3155 10.25C19.3165 10.1159 19.2642 9.98683 19.1701 9.89122L11.092 1.49411C10.9338 1.32933 10.7439 1.19817 10.5337 1.10849C10.3236 1.01881 10.0975 0.972446 9.86908 0.972176C9.64061 0.971905 9.41443 1.01773 9.20409 1.10692C8.99375 1.1961 8.80356 1.32681 8.64491 1.49122L0.556788 9.86919C0.499426 9.91484 0.452446 9.97219 0.418974 10.0374C0.385502 10.1026 0.366306 10.1742 0.362664 10.2475C0.359022 10.3207 0.371016 10.3938 0.39785 10.4621C0.424684 10.5303 0.46574 10.592 0.518288 10.6431C0.570835 10.6942 0.633668 10.7336 0.702605 10.7585C0.771541 10.7835 0.844999 10.7934 0.918091 10.7878C0.991182 10.7821 1.06223 10.761 1.12651 10.7257C1.19078 10.6904 1.24681 10.6419 1.29086 10.5833L9.38883 2.21125C9.45101 2.14709 9.52546 2.0961 9.60776 2.06131C9.69005 2.02652 9.77851 2.00865 9.86785 2.00875C9.9572 2.00886 10.0456 2.02694 10.1278 2.06193C10.21 2.09691 10.2844 2.14808 10.3464 2.21239L18.4245 10.6036C18.4959 10.6775 18.5876 10.7285 18.688 10.7502C18.7884 10.7719 18.893 10.7633 18.9885 10.7254C19.084 10.6875 19.1661 10.622 19.2243 10.5374C19.2825 10.4528 19.3143 10.3527 19.3155 10.25Z",
    fill: "#E83A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRed);
export default __webpack_public_path__ + "static/media/dropdown-red.5bf4f413f2cca8fe4e4d35fea6ad9491.svg";
export { ForwardRef as ReactComponent };